export var source = "query SubscriptionCoupon {\n  user {\n    subscription {\n      coupon\n    }\n  }\n}";
export default source;